// extracted by mini-css-extract-plugin
export default {"wrapper":"EmbedV1_wrapper__QPTSy","inner":"EmbedV1_inner__Ivnnq"};